var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-content-submenu',{ref:"contentMenu"}),_c('v-row',{staticClass:"mx-7",staticStyle:{"padding-top":"100px"},attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Submit New Application")])]),_c('v-col',{attrs:{"cols":"12"}},[_c('q-new-application')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }